/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksList/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import BulkActions from './BulkActions/index'
import Content from './Content/index'
import MoveModal from './MoveModal/index'
import React from 'react'
import TasksFilters from 'DesignSystem/TasksFilters/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TasksList({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let filtersValueData = fromData.useDataValue({ viewPath,
context: 'filters',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let selectedBulkTaskIdsValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_task_ids',
format: fromFormat.isNotEmptyList,
})
  return (<React.Fragment
>
<div
  data-testid="TasksList.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2t9bz6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z2t9bz6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-Z2t9bz6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z2t9bz6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TasksFilters
  viewPath={`${viewPath}/TasksFilters`}
 onChange={onChange}
 data="tab.selected.board_id"
 boardId={tabSelectedBoardIdValueData}
 data="filters"
 syncFilters={filtersValueData}
/>
<fromFlow.When is={selectedBulkTaskIdsValueData}>
<BulkActions
  viewPath={`${viewPath}/BulkActions`}
 data="selected.bulk_task_ids"
 format="/Data/format.js isNotEmptyList"
/>
</fromFlow.When>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
<MoveModal
  viewPath={`${viewPath}/MoveModal`}
/>
{children}
</React.Fragment>)
}